import API_STRINGS from 'constants/Api';
import jwtAxios from '@tenant/services/auth/jwt-auth';

export const getApps = async (query) => {
  const response = await jwtAxios.get(API_STRINGS.APP_MANAGER.GET_LIST, {
    params: query,
  });
  return response.data;
};

export const getAppDetail = async (query) => {
  const response = await jwtAxios.get(
    API_STRINGS.APP_MANAGER.GET_DETAIL + '/' + query?.appId,
  );
  return response.data;
};

export const getAppCategories = async (query) => {
  const response = await jwtAxios.get(API_STRINGS.APP_MANAGER.GET_CATEGORIES);
  return response.data;
};

export const publishApp = async (data) => {
  const response = await jwtAxios.post(
    API_STRINGS.APP_MANAGER.PUBLISH_APP + '/' + data?.AppId,
    data,
  );
  return response.data;
};

export const rePublishApp = async (data) => {
  const response = await jwtAxios.patch(
    API_STRINGS.APP_MANAGER.RE_PUBLISH_APP + '/' + data?.AppId,
    data,
  );
  return response.data;
};

export const unpublishApp = async (data) => {
  const response = await jwtAxios.patch(
    API_STRINGS.APP_MANAGER.UNPUBLISH_APP + '/' + data?.appId,
    data,
  );
  return response.data;
};

export const createApp = async (data) => {
  const response = await jwtAxios.post(
    API_STRINGS.APP_MANAGER.CREATE_APP,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response.data;
};

export const editApp = async (data) => {
  const response = await jwtAxios.post(
    API_STRINGS.APP_MANAGER.EDIT_APP + '/' + data?.AppId,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response.data;
};

export const toggleShowReviews = async (data) => {
  const response = await jwtAxios.post(
    API_STRINGS.APP_MANAGER.TOGGLE_SHOW_REVIEWS,
    data,
  );
  return response.data;
};

export const getBAUModules = async (query) => {
  const response = await jwtAxios.get(API_STRINGS.APP_MANAGER.GET_BAU_MODULES, {
    params: query,
  });

  const mappedResponse = response.data.map((item) => ({
    id: item.Id,
    name: item.Name,
  }));
  return mappedResponse;
};

export const getAppPricing = async (data) => {
  const response = await jwtAxios.get(
    API_STRINGS.APP_MANAGER.GET_APP_PRICING(data?.appId),
  );
  return response.data;
};

export const upsertAppPricing = async (data) => {
  const response = await jwtAxios.post(
    API_STRINGS.APP_MANAGER.UPSERT_APP_PRICING(data?.appId),
    data,
  );
  return response.data;
};

export const getExportCSV = async (query) => {
  const response = await jwtAxios.get(API_STRINGS.APP_MANAGER.EXPORT_LIST_APP);
  return response.data;
};

export const editAppDescription = async (data) => {
  const response = await jwtAxios.post(
    API_STRINGS.APP_MANAGER.EDIT_APP_DESCRIPTION(data?.AppId),
    data,
  );
  return response.data;
};

export const editAppGeneral = async (data) => {
  const response = await jwtAxios.post(
    API_STRINGS.APP_MANAGER.EDIT_APP_GENERAL(data?.AppId),
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response.data;
};

export const editAppConfig = async (data) => {
  const appId = data instanceof FormData ? data.get('AppId') : data?.AppId;
  const response = await jwtAxios.post(
    API_STRINGS.APP_MANAGER.EDIT_APP_CONFIG(appId),
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response.data;
};

export const getAppPermissions = async (appId) => {
  const response = await jwtAxios.get(
    API_STRINGS.APP_MANAGER.GET_APP_PERMISSIONS,
    {
      params: { AppId: appId },
    }
  );
  return response.data;
};

export const getNextAvailablePermissionId = async () => {
  const response = await jwtAxios.get(
    'api/apps/permissions/next-available-id'
  );
  return response.data;
};

export const checkPermissionIdExists = async (permissionId) => {
  const response = await jwtAxios.get(
    'api/apps/permissions/check-exists',
    {
      params: { permissionId },
    }
  );
  return response.data;
};

export const addAppPermission = async (data) => {
  const response = await jwtAxios.post(
    'api/apps/permissions',
    data
  );
  return response.data;
};

export const deleteAppPermission = async (data) => {
  const response = await jwtAxios.delete(
    'api/apps/permissions',
    { data }
  );
  return response.data;
};

export const syncAppPermission = async (data) => {
  const response = await jwtAxios.post(
    'api/apps/permissions/data-correction',
    data
  );
  return response.data;
};

export const updateAppPermission = async (data) => {
  const response = await jwtAxios.put(
    API_STRINGS.APP_MANAGER.UPDATE_APP_PERMISSION,
    data
  );
  return response.data;
};

// Portal Permission API functions
export const getAppPortalPermissions = async (appId) => {
  const response = await jwtAxios.get(
    'api/apps/portal-permissions',
    {
      params: { AppId: appId },
    }
  );
  return response.data;
};

export const getNextAvailablePortalPermissionId = async () => {
  const response = await jwtAxios.get(
    'api/apps/portal-permissions/next-available-id'
  );
  return response.data;
};

export const checkPortalPermissionIdExists = async (permissionId) => {
  const response = await jwtAxios.get(
    'api/apps/portal-permissions/check-exists',
    {
      params: { permissionId },
    }
  );
  return response.data;
};

export const addAppPortalPermission = async (data) => {
  const response = await jwtAxios.post(
    'api/apps/portal-permissions',
    data
  );
  return response.data;
};

export const deleteAppPortalPermission = async (data) => {
  const response = await jwtAxios.delete(
    'api/apps/portal-permissions',
    { data }
  );
  return response.data;
};

export const syncAppPortalPermission = async (data) => {
  const response = await jwtAxios.post(
    'api/apps/portal-permissions/data-correction',
    data
  );
  return response.data;
};

export const updateAppPortalPermission = async (data) => {
  const response = await jwtAxios.put(
    'api/apps/portal-permissions',
    data
  );
  return response.data;
};
